/* ================================================
   GLOBAL JAVASCRIPT
   Amina Moroccan Home Theme
   ================================================ */

// Cart functionality
class CartManager {
  constructor() {
    this.cartCount = document.querySelector('[data-cart-count]');
    this.init();
  }

  init() {
    // Add to cart buttons
    document.querySelectorAll('[data-product-add]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.addToCart(btn.dataset.productAdd);
      });
    });
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        this.updateCartCount();
        this.showNotification('Added to cart!');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      if (this.cartCount) {
        this.cartCount.textContent = cart.item_count;
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  showNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
        <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd"/>
      </svg>
      <span>${message}</span>
    `;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.classList.add('active');
    }, 10);

    setTimeout(() => {
      notification.classList.remove('active');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
}

// Scroll reveal animation
class ScrollReveal {
  constructor() {
    this.revealElements = document.querySelectorAll('.reveal');
    this.init();
  }

  init() {
    if (this.revealElements.length) {
      this.reveal();
      window.addEventListener('scroll', () => this.reveal());
    }
  }

  reveal() {
    this.revealElements.forEach(element => {
      const windowHeight = window.innerHeight;
      const elementTop = element.getBoundingClientRect().top;
      const revealPoint = 150;

      if (elementTop < windowHeight - revealPoint) {
        element.classList.add('active');
      }
    });
  }
}

// Lazy loading images
class LazyLoader {
  constructor() {
    this.init();
  }

  init() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const image = entry.target;
            if (image.dataset.src) {
              image.src = image.dataset.src;
              image.removeAttribute('data-src');
            }
            observer.unobserve(image);
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function() {
  new CartManager();
  new ScrollReveal();
  new LazyLoader();
});

// Add notification styles
const notificationStyles = document.createElement('style');
notificationStyles.textContent = `
  .cart-notification {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    background-color: var(--color-secondary);
    color: white;
    border-radius: 8px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    transform: translateY(100px);
    opacity: 0;
    transition: transform 0.3s ease, opacity 0.3s ease;
    z-index: 9999;
  }
  
  .cart-notification.active {
    transform: translateY(0);
    opacity: 1;
  }
  
  .cart-notification svg {
    color: var(--color-accent);
  }
`;
document.head.appendChild(notificationStyles);
